import {
  Button,
  Highlight,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
import Aos from "aos";
import "aos/dist/aos.css";
import GithubComp from "./GithubComp";

// Frontend
import htmlLogo from "../images/html.png";
import CSS from "../assets/css.png";
import Javascript from "../assets/javascript.png";
import ReactLogo from "../assets/react.png";
import nextjs from "../assets/nextjs.png";
import Redux from "../assets/redux.png";
import ChakraUI from "../assets/chakra.png";
import MaterialUI from "../assets/material-ui.png";
import Bootsrap from "../assets/Bootstrap_logo.svg.png";
import Tailwind from "../assets/tailwind.png";
import Bitbucket from "../assets/bitbucket.jpeg";
import Sitecore from "../assets/sitecore.png";
import Github from "../assets/github.png";
import ShadCn from "../assets/shadcn.png";
import AntDesign from "../assets/antdesign.png";

// Backend & API
import Node from "../assets/node.png";
import Express from "../assets/express.png";
import websocket from "../assets/socket.svg";
import Mongoose from "../assets/mongoose.png";
import Postman from "../assets/postman.png";

import Mongo from "../assets/mongodb.png";
import Git from "../assets/git.png";
import Docker from "../assets/docker.png";
import Dotnet from "../assets/dotnet.png";
import Fastify from "../assets/fastify.png";
import Hono from "../assets/hono.png";
import GCP from "../assets/GCP.png";
import Azure from "../assets/azure.png";
import Supabase from "../assets/supabase.png";
import Vercel from "../assets/vercel.svg";

// Design
import Photoshop from "../assets/photoshop.png";
import Corel from "../assets/corel.png";
import Illustratir from "../assets/adobe.png";
import Effects from "../assets/after.png";

const skillsD = [
  // Frontend
  { img: htmlLogo, name: "HTML", type: "front" },
  { img: CSS, name: "CSS", type: "front" },
  { img: Javascript, name: "JavaScript", type: "front" },
  { img: ReactLogo, name: "React.js", type: "front" },
  { img: nextjs, name: "Next.js", type: "front" },
  { img: Redux, name: "Redux / Recoil", type: "front" },
  { img: ChakraUI, name: "Chakra UI", type: "front" },
  { img: MaterialUI, name: "Material UI", type: "front" },
  { img: Bootsrap, name: "Bootstrap", type: "front" },
  { img: Tailwind, name: "Tailwind CSS", type: "front" },
  { img: ShadCn, name: "ShadCN UI", type: "front" },
  { img: AntDesign, name: "AntDesign UI", type: "front" },

  // Backend
  { img: Node, name: "Node.js", type: "back" },
  { img: Express, name: "Node + Express.js", type: "back" },
  { img: Hono, name: "Node + Hono", type: "back" },
  { img: Fastify, name: "Node + Fastify", type: "back" },

  { name: "Sitecore", type: "back", img: Sitecore },

  { img: Dotnet, name: ".NET (C#)", type: "back" },
  { img: websocket, name: "WebSocket", type: "back" },
  { img: Postman, name: "Postman / API Testing", type: "back" },

  // Database
  { img: Mongo, name: "MongoDB", type: "database" },
  { img: Mongoose, name: "Mongoose", type: "database" },
  { name: "MySQL", type: "database" },
  { img: Supabase, name: "Supabase (PostgreSQL)", type: "database" },

  // DevOps
  { img: Git, name: "Git", type: "devops" },
  { img: Github, name: "GitHub", type: "devops" },
  { img: Bitbucket, name: "Bitbucket", type: "devops" },
  { img: Vercel, name: "Vercel", type: "devops" },
  { img: GCP, name: "GCP", type: "devops" },
  { img: Azure, name: "Azure", type: "devops" },
  { img: Docker, name: "Docker", type: "devops" },

  // Design
  { img: Photoshop, name: "Photoshop", type: "graphic" },
  { img: Corel, name: "Corel Draw", type: "graphic" },
  { img: Illustratir, name: "Illustrator", type: "graphic" },
  { img: Effects, name: "After Effects", type: "graphic" },
];

const buttonData = [
  { name: "All", value: "all" },
  { name: "Frontend", value: "front" },
  { name: "Backend", value: "back" },
  { name: "Database", value: "database" },
  { name: "DevOps", value: "devops" },
  { name: "Design", value: "graphic" },
];

const Skills = () => {
  const [data, setData] = useState(skillsD);
  const [selectedBtn, setSelectedBtn] = useState(0);

  const FilterData = (type) => {
    if (type === "all") {
      setData(skillsD);
      return;
    }
    const newData = skillsD.filter((el) => el.type === type);
    setData(newData);
  };

  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);

  const HeadingColor = useColorModeValue("black", "white");
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");
  const selected = useColorModeValue("#e53e3e", "#b5925f");

  const SkillColor = useColorModeValue(
    "linear-gradient(3deg, rgb(236,240,243) 0%, rgba(175,188,255,0) 70%)",
    "whiteAlpha.100"
  );
  const hovekaro = useColorModeValue("white", "blackAlpha.500");
  const bg = useColorModeValue(
    "white",
    "linear-gradient(221deg, rgba(14,4,4,1) 0%, rgba(61,61,61,1) 51%, rgba(64,64,64,1) 60%, rgba(55,55,55,1) 70%, rgba(14,4,4,1) 100%)"
  );

  return (
    <Stack
      position="relative"
      id="skills"
      p={{ base: 0, lg: 8 }}
      w="full"
      bg={bg}
    >
      <Stack
        data-aos="fade-right"
        justifyContent="space-around"
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="1400px"
        flexFlow="column"
      >
        <Tilt>
          <Stack data-aos="fade-up">
            <Text
              color={HeadingColor}
              marginTop={50}
              fontSize={{ base: "2xl", md: "3xl", xl: "4xl" }}
              fontWeight="semibold"
            >
              <Highlight query="Skills" styles={{ color: QueryColor }}>
                My Skills
              </Highlight>
            </Text>
          </Stack>
        </Tilt>

        <HStack
          data-aos="zoom-in"
          justifyContent="center"
          w="full"
          flexFlow="row wrap"
          spacing={{ base: 2, sm: 5 }}
          gap={2}
          p={{ base: 0, sm: 5 }}
        >
          {buttonData.map((el, i) => (
            <Button
              key={i}
              borderRadius={5}
              onClick={() => {
                FilterData(el.value);
                setSelectedBtn(i);
              }}
              color={selectedBtn === i ? "white" : "none"}
              bg={selectedBtn === i ? selected : "whiteAlpha.200"}
              _hover={{ bg: selected, color: "white" }}
              boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
              fontWeight="medium"
              size={{ base: "sm", sm: "md" }}
            >
              {el.name}
            </Button>
          ))}
        </HStack>

        <SimpleGrid
          w="full"
          justifyItems="center"
          justifyContent="center"
          p={{ base: 5, md: 0, lg: 5 }}
          spacing={{ base: 1, md: 3, lg: 5, xl: 10 }}
          columns={{ base: 4, sm: 4, md: 7, lg: 7, xl: 8 }}
        >
          {data.map((el, idx) => (
            <VStack
              key={idx}
              justifyContent="space-around"
              bg={SkillColor}
              w={{ base: "80px", md: "80px", lg: "100px", xl: "120px" }}
              p={{ base: 3, md: 2, lg: 3 }}
              borderRadius={5}
              _hover={{
                shadow:
                  "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                bg: hovekaro,
              }}
            >
              {el.img && <Image src={el.img} w="full" alt={el.name} />}
              <Text
                fontSize={{ base: "10px", md: "12px", lg: "13px", xl: "15px" }}
              >
                {el.name}
              </Text>
            </VStack>
          ))}
        </SimpleGrid>
      </Stack>
      <GithubComp />
    </Stack>
  );
};

export default Skills;
